function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 2L14 13.9395",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0012 2.00101L2.03125 14.001",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round"
});
const SvgCloseModalPureIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseModalPureIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-modal-pure-icon.bb295b1f.svg";
export { ForwardRef as ReactComponent };